import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { TallyMark } from "../common/TallyMark";
/** The Log.Soccer wordmark: the solid tally mark + "LOG.SOCCER", rendered as
 * SVG + text (was a raster PNG). `color` drives both the mark and the text, so
 * it works on any ground (the nav bar passes white on navy). */
export const Logo = ({ height = 30, color = "#fff", }) => (_jsxs(Box, { component: Link, to: "/", "aria-label": "Log.Soccer Home", sx: {
        display: "inline-flex",
        alignItems: "center",
        gap: `${Math.round(height * 0.24)}px`,
        textDecoration: "none",
        color,
    }, children: [_jsx(TallyMark, { size: height, color: color }), _jsx(Box, { component: "span", sx: {
                fontFamily: '"Poppins", system-ui, sans-serif',
                fontWeight: 800,
                fontSize: `${Math.round(height * 0.72)}px`,
                lineHeight: 1,
                letterSpacing: "0.005em",
                color,
            }, children: "LOG.SOCCER" })] }));
